/**
 * Themes queries
 */

import gql from 'graphql-tag'

export const themesQuery = gql`
  query GetThemesByProduct($id: Int!) {
    themes: getThemesByProduct(productId: $id, showFeatured: true) {
      id
      image
      name
    }
  }
`

export const stylesQuery = gql`
  query getStylesFilterByParams(
    $productId: Int!,
    $themeId: Int,
    $colorPalette: [String],
    $searchParams: [String],
    $limit: Int,
    $offset: Int,
    $orderAs: String,
    $shouldShowFavorites: Boolean,
    $selectedDesign: Int
  ) {
    result: getStylesFilterByParams(
      productId: $productId,
      themeId: $themeId,
      fromCustomer: true,
      colorPalette: $colorPalette
      searchParams: $searchParams
      limit: $limit
      offset: $offset
      orderAs: $orderAs
      shouldShowFavorites: $shouldShowFavorites
      selectedDesign: $selectedDesign
    ) {
      fullCount
      styles {
        id
        styleId: style_id
        name
        image
        width
        height
        brandingPng: branding_png
        brandingPngGlb: branding_variant_glb
        thumbnail
        canvas
        keywords
        itemOrder: item_order
        colorOne: block1_value
        colorTwo: block2_value
        colorThree: block3_value
        colorFour: block4_value
        colorFive: block5_value
        colorOneImage: colorblock1_image
        colorTwoImage: colorblock2_image
        colorThreeImage: colorblock3_image
        colorFourImage: colorblock4_image
        colorFiveImage: colorblock5_image
        likes
        previousLikes: previous_likes
        hearts
        themeId: theme_id
        themeName: theme_name
      }
    }
  }
`

export const styleSingleQuery = gql`
  query getStyleByName(
    $productId: Int!,
    $themeId: String,
    $design: String!
  ) {
    result: getStyleByName(
      productId: $productId,
      themeId: $themeId,
      design: $design
    ) {
      id
      styleId: style_id
      name
      image
      width
      height
      brandingPng: branding_png
      brandingPngGlb: branding_variant_glb
      thumbnail
      canvas
      keywords
      itemOrder: item_order
      colorOne: block1_value
      colorTwo: block2_value
      colorThree: block3_value
      colorFour: block4_value
      colorFive: block5_value
      colorOneImage: colorblock1_image
      colorTwoImage: colorblock2_image
      colorThreeImage: colorblock3_image
      colorFourImage: colorblock4_image
      colorFiveImage: colorblock5_image
      likes
      previousLikes: previous_likes
      hearts
      themeId: theme_id
      themeName: theme_name
    }
  }
`

export const likeStyleMutation = gql`
  mutation likeStyle($styleId: Int!, $isColorCombo: Boolean) {
    likeStyle(styleId: $styleId, isColorCombo: $isColorCombo) {
      message
      likes
    }
  }
`

export const saveStyleToFavoritesMutation = gql`
  mutation saveStyle($styleId: Int!, $isColorCombo: Boolean) {
    saveStyle(styleId: $styleId, isColorCombo: $isColorCombo) {
      message
      hearts
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterThemeGallery/FilteredDesignsSection/data.ts